export default "__VITE_ASSET__MRbIeIFA__"